import axios from 'axios';
import {BE_SERVER_ENDPOINT, API_PROTOCOL} from '../constants/configs.js';
import { getBECompatibleLocale } from '../helpers/helper.js';
export const FETCH_APPLIANCE_LIST_ACTIONS = {
    FETCH_APPLIANCES_SUCCESS: 'FETCH_APPLIANCES_SUCCESS',
    FETCH_APPLIANCES_FAILED: 'FETCH_APPLIANCES_FAILED'
};

export function fetchApplianceMapping(uuid, locale) {
  return dispatch => {
    axios.get(API_PROTOCOL + BE_SERVER_ENDPOINT + '/v2.0/dashboard/users/' + uuid + '/appliance-name-mapping', {
        params: {
            locale: locale
        }
    }).then(
      (response) => {
        dispatch({
          type: FETCH_APPLIANCE_LIST_ACTIONS.FETCH_APPLIANCES_SUCCESS,
          payload: response.data.payload
        })
      },
      (error) =>{
        dispatch({
            type: FETCH_APPLIANCE_LIST_ACTIONS.FETCH_APPLIANCES_FAILED,
            payload: error
        })
      }
    )
  }
}
